import configLoader from './../../helpers/configs/ConfigLoader';

class ApiPayloadService {
  constructor() {
    this.payload = {
        load: {
            pageId: '',
            accessId: configLoader.get("ACCESS_KEY"),
            data: {
                subsidiaryCode: configLoader.get("SUBSIDIARY_CODE"),
                userId: -1,
            },
            redirectRoute: '',
            device: localStorage.getItem(configLoader.get("DEVICE_FINGERPRINT")),
            apiToken: configLoader.get("API_TOKEN"),
        },
    };
  }

  // Get full payload (deep clone for safety)
  fetchPayload() {
    return structuredClone(this.payload);
  }

  // Get value (dot-notation for nested)
  get(key) {
    const parts = key.split('.');
    let current = this.payload;
    for (const part of parts) {
      if (current == null) return null;
      current = current[part];
    }
    return current ?? null;
  }

  // Set/update value (dot-notation, adds if missing)
  set(key, value) {
    const parts = key.split('.');
    let current = this.payload;
    for (let i = 0; i < parts.length - 1; i++) {
      const part = parts[i];
      if (current[part] === undefined) current[part] = {};
      current = current[part];
    }
    current[parts[parts.length - 1]] = value;
  }
}

// Singleton instance
const apiPayload = new ApiPayloadService();
export default apiPayload;